var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],class:{ 'invalid-feedback': _vm.error },staticStyle:{"display":"block"}},[_c('span',[_vm._v(_vm._s(_vm.error))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05bcf5e5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/common/Error.vue
// module id = 1zRa
// module chunks = 0 1